<template>
  <div class="bottom-nav-spacing">
    <v-app-bar
      :class="{'appbar-transparent-overlay': theme.collection_banner}" :dark="theme.collection_banner"
      absolute color="transparent" elevation="0" height="90" max-height="90" v-if="$vuetify.breakpoint.smAndDown"
    >
      <div class="container d-flex align-center pa-0">
        <v-spacer></v-spacer>
        <v-btn @click="$store.dispatch('cart/show')" class="mr-0" icon>
          <v-badge :content="`${$store.state.cart.items.length}`" color="red" overlap>
            <v-icon>mdi-cart</v-icon>
          </v-badge>
        </v-btn>
      </div>
    </v-app-bar>

    <v-container class="pa-0" fluid v-if="theme.collection_banner">
      <CatalogueBanner/>
    </v-container>
    <v-card class="border-bottom pt-10 pb-5" elevation="0" rounded="0" v-else>
      <v-container class="pt-10">
        <div class="text-h5 font-weight-bold">Buy on credit</div>
        <p class="ma-0 mt-2">Pay back in installments</p>
      </v-container>
    </v-card>

    <v-container
      class="flex-grow-1 overflow-hidden mt-1"
    >
      <div class="d-flex align-center mb-5">
        <v-btn @click="layout = 'grid'" class="mr-1" :color="layout !== 'full' ? 'primary' : 'grey'" dark icon>
          <v-icon>mdi-view-grid</v-icon>
        </v-btn>
        <v-btn @click="layout = 'full'" class="mr-1" :color="layout !== 'grid' ? 'primary' : 'grey'" dark icon>
          <v-icon>mdi-view-agenda</v-icon>
        </v-btn>
        <v-btn @click="views = {...views, search: true }" class="ml-auto" color="grey darken-3" text rounded>
          <v-icon left size="18">mdi-magnify</v-icon>
          Search
        </v-btn>
      </div>
      <ProductsList :items="items" :layout="layout"/>
    </v-container>

    <!-- Search & Filter -->
    <v-bottom-sheet inset max-width="500" v-model="views.search">
      <v-sheet class="pa-8 py-6">
        <v-tabs background-color="transparent" grow v-model="searchTab">
          <v-tab>Search</v-tab>
          <v-tab>Filter</v-tab>
        </v-tabs>
        <v-tabs-items v-model="searchTab">
          <v-tab-item class="py-10">
            <br><br><br>
            <SearchItems @close="views = { ...views, search: false }"/>
            <br><br><br>
          </v-tab-item>
          <v-tab-item class="py-10">
            <FilterItemsSide @close="views = { ...views, search: false }"/>
          </v-tab-item>
        </v-tabs-items>
      </v-sheet>
    </v-bottom-sheet>

    <v-bottom-sheet inset max-width="500" v-model="views.about">
      <About @close="views = { ...views, about: false }"/>
    </v-bottom-sheet>

    <v-bottom-sheet inset max-width="500" v-model="views.referral">
      <Referral @close="views = { ...views, referral: false }"/>
    </v-bottom-sheet>

    <BottomNavigationStore/>
  </div>
</template>

<script>
import FilterItemsSide from "../FilterItemsSide"
import ProductsList from "./ProductsList"
import SearchItems from "../SearchItems"
import catalogue from "../../mixins/catalogue";
import About from "../../views/About";
import Referral from "../referral/Referral";
import CatalogueBanner from "./CatalogueBanner";
import BottomNavigationStore from "../nav/BottomNavigationStore";

export default {
  name: 'CatalogueMobile',
  mixins: [catalogue],
  components: { BottomNavigationStore, CatalogueBanner, Referral, About, FilterItemsSide, ProductsList, SearchItems },
  data() {
    return {
      theme: this.$store.getters['merchant/theme']
    }
  }
}
</script>
<style lang="scss" scoped>
@import '../../assets/variables';

.parent {
  margin-top: var(--nav-spacing);
  height: calc((var(--vh, 1vh) * 100) - var(--nav-spacing));
}
</style>
